import { render, staticRenderFns } from "./NonTrade.vue?vue&type=template&id=1c93cc4a&"
import script from "./NonTrade.vue?vue&type=script&lang=js&"
export * from "./NonTrade.vue?vue&type=script&lang=js&"
import style0 from "./NonTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports